import { loadableWithFallback } from '@vision/ui/utils';
import type { TrendChart4Props } from './TrendChart4';

export const TrendChart4 = loadableWithFallback<TrendChart4Props>(() => import('./TrendChart4'));
